<template>
    <div>
        <v-menu offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on }">
                <v-btn text small fab v-on="on">
                    <v-avatar size="40" small v-if="showAvatar && user.avatar">
                        <v-img :src="user.avatar" :alt="user.name"></v-img>
                    </v-avatar>
                    <v-icon v-else>fas fa-user</v-icon>
                </v-btn>
            </template>
            <v-list style="min-width:250px;">
                <v-list-item>
                    <v-list-item-title class="pb-4">
                        Welcome<br /><b>{{ user.demo_mode ? "DEMO MODE" : $auth.auth_user.name}}</b>!
                        <span v-if="isImpersonating"><em>Impersonating</em></span>
                    </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="isImpersonating" @click="revertImpersonation">
                    <v-list-item-avatar>
                        <v-icon small>fas fa-undo-alt</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title>Switch Back</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{name:'User Profile'}">
                    <v-list-item-avatar>
                        <v-icon small>fas fa-user</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title>My Profile</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{name:'My Exports'}">
                    <v-list-item-avatar>
                        <v-icon small>fas fa-file-csv</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title>My Exports</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="hasRole(['SuperAdmin'])">
                        <v-list-item-avatar>
                            <v-icon small>fas fa-user</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-title>Demo Mode</v-list-item-title>
                        <v-list-item-action class="pr-4">
                            <v-switch v-model="user.demo_mode" @click="toggleDemoMode()"></v-switch>
                        </v-list-item-action>
                </v-list-item>
                <v-list-item v-if="user.demo_mode" :to="{ name: 'AgentDetail', params: { agentcode: demoAgentCode} }">
                    <v-list-item-avatar>
                        <v-icon small>fas fa-user</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title>Demo Agent Profile</v-list-item-title>
                </v-list-item>
                <!-- todo_Division //-->
                <v-divider v-if="enabledTenants.length > 1"></v-divider>
                <v-item-group v-if="enabledTenants.length > 1" class="tenant-list">
                    <v-subheader v-if="quilityTenants.length > 1">Tenants</v-subheader>
                    <v-list-item v-for="(t, key) in quilityTenants" @click="changeTenant(t)" :key="key">
                        <v-list-item-avatar>
                            <v-icon small>fas fa-chevron-right</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-title>{{t.Tenant}}</v-list-item-title>
                    </v-list-item>
                    <v-subheader v-if="restTenants.length > 1">Other tenants</v-subheader>
                    <v-list-item v-for="(t, key) in restTenants" @click="changeTenant(t)" :key="key">
                        <v-list-item-avatar>
                            <v-icon small>fas fa-chevron-right</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-title>{{t.Tenant}}</v-list-item-title>
                    </v-list-item>
                </v-item-group>
                <v-divider></v-divider>
                <v-list-item @click="logout">
                    <v-list-item-avatar>
                        <v-icon small>fas fa-sign-out-alt</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-title>Logout</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>
<script>
import QuilityAPI from '@/store/API/QuilityAPI.js'
import { EventBus } from '@/event-bus';
export default {
    name: "QUserMenu",
    props: {
        showAvatar: { type: Boolean, default: true },
    },
    data: () => ({
        // demo_mode: false,
    }),
    computed: {
        enabledTenants () {
            return this.all_enabled_tenants.filter(tenant => tenant.Tenant !== 'Unassigned Agents')
        },
        quilityTenants() {
            return this.enabledTenants.filter(({ Tenant }) => Tenant.includes('Quility') || Tenant.includes('B2B'))
        },
        restTenants() {
            return this.enabledTenants.filter(({ AgentCodePrefix }) => AgentCodePrefix
                && !this.quilityTenants.some(tenant => tenant.AgentCodePrefix === AgentCodePrefix))
                .sort((a, b) => a.Tenant > b.Tenant ? 1 : -1)
        },
        demoAgentCode() {
            return process.env.VUE_APP_DEMO_AGENT_CODE ?? 'BTB0078291'
        }
    },
    methods: {
        logout() {
            this.$auth.logout({
                returnTo: window.location.origin
            });
        },
        revertImpersonation() {
            var g = this
            QuilityAPI.revertImpersonation().then(function(json) {
                if (json.success == true) {
                    //redirect the admin back to the detail page for that agent. 
                    if (window.location.hostname == "localhost") {
                        document.location.href = "http://localhost:8080/agents/" + json.AgentCode;
                    } else {
                        document.location.href = 'https://' + window.location.hostname + "/agents/" + json.AgentCode;
                    }
                }
            })
        },
        changeTenant(d) {
            EventBus.$emit('changeTenant', d)
            this.$router.go()
        },
        toggleDemoMode() {
            var g = this
            QuilityAPI.toggleDemoMode().then(function(json) {
                g.user.demo_mode = json.demo_mode
                if (json.success == true) {
                    window.location.reload()
                }
            })
        }
    },
    watch: {

    },
}
</script>
<style scoped>
    .tenant-list{
        max-height: min(500px, 50svh);/* or any height you want */
        overflow-y:auto
    }
</style>